import { useState } from 'react';
import axios from 'axios';
import { useAuthLocalStorage } from '../../modules/useLocalStore';
import style from './settings.module.css'
import UploadPhotoBig from '../../img/no_photo.png'
import Money from '../../img/coin.png'
import Search from '../../modules/city/city';
import CustomSelect from '../../modules/select/select';
import Radioselect from '../../modules/radioselect/radioselect';
import Photo from '../../modules/Photo/photo';

function Settings({myProfile,setMyProfile,activePhoto,setActivePhoto,page,setPage}){
    const days = Array.from({ length: 31 }, (_, i) => i + 1);
    const months = [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ];
    const targets = [
        'Без обязательств',
        'Серьезные отношения',
        'Дружеское общение',
        'Флирт и свидания'
    ];
    const hobby = [
        'Велопрогулки',
        'Прогулки',
        'Фото',
        'Живопись',
        'Путешествия',
        'Кулинария',
        'Фитнес',
        'Музыка',
        'Видеоигры',
        'Рыбалка',
        'Спорт',
        'Вязание',
        'Танцы',
        'Плавание',
        'Астрономия',
        'Театр',
        'Пикники',
        'Дайвинг',
        'Медитация',
        'Походы',
        'Кино'
    ];
    const years = Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i);
    
    const [day, setDay] = useState(myProfile.day);
    const [month, setMonth] = useState(myProfile.month);
    const [year, setYear] = useState(myProfile.year);
    const [target, setTarget] = useState(myProfile.target);
    const [cityz,setCityz] = useState(myProfile.city);
    const [hobbyz,setHobby] = useState(myProfile.hobby);
    const [name,setName] = useState(myProfile.name);
    const [opis,setOpis] = useState(myProfile.text);
    const [openPh,setOpenPh] = useState(null);
    const { getToken, removeToken } = useAuthLocalStorage();
    const token = getToken();

    const changeOpenPh = (e) => {
        setOpenPh(e);
    };

    const setTextOpis = (e) => {
        setOpis(e.target.value);
    };

    const handleNameChange = (e) => {
        setName(e.target.value);
    };

    const handleDayChange = (e) => {
        setDay(e.target.value);
    };


    const handleMonthChange = (e) => {
        setMonth(e.target.value);
    };

    const handleYearChange = (e) => {
        setYear(e.target.value);
    };
    const SaveProfile = () =>
    {
        if(name.length < 2)
            return alert('Заполните имя');
        if(cityz.length < 2)
            return alert('Выберите город из списка');
        if(hobbyz.length < 1)
            return alert('Выбирите увлечение');
        if(target.length < 1)
            return alert('Выбирите цель');
        if(opis.length < 10)
            return alert('Введите описание (Минимум 10)');
        if(token !== null)
        {
            let opp = '';
            if(myProfile.vip <= 0) opp = sanitizeText(opis).join(" ");
            else opp = opis;
            const data = {
                name: name,
                day: day,
                month: month,
                year: year,
                city: cityz,
                target: target,
                text: opp,
                hobby: hobbyz
            };
            const config = {
                headers: {
                    Authorization: "Bearer " + token
                }
            };
            
            axios.post(`https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/updateProfile`, data,config)
            .then(response => {
                const updatedProfile = {...myProfile, 
                    name: name,
                    day: day,
                    month: month,
                    year: year,
                    city: cityz,
                    target: target,
                    text: opp,
                    hobby: hobbyz,
        
                }
                setMyProfile(updatedProfile);
                setOpis(opp);
                PopupOpen(22);
                
            })
            .catch(error => {
                console.error('Error update data:', error);
            });
           
        };
        
    };
    function sanitizeText(text) {
        const numberWords = [
            "ноль","один","два","три","четыре","пять","шесть","семь","восемь","девять"
        ];
    
        const tgWords = [
            "тг", "tg", "телеграм", "телеграмм",
            "telegram", "telegramm", "телега", "тгшка", "тэгэ"
        ];
    
        let maskCount = 0; // для уникальных ключей
    
        // 1. Скрываем последовательности цифр ≥3
        text = text.replace(/\d{3,}/g, "###MASK###");
    
        // 2. Скрываем слитные слова-цифры ≥3
        const concatenatedWordsRegex = new RegExp(`(?:${numberWords.join("|")}){3,}`, "gi");
        text = text.replace(concatenatedWordsRegex, "###MASK###");
    
        // 3. Разбиваем текст по пробелам
        const words = text.split(/\s+/);
        const result = [];
        let i = 0;
        const pemen = '*Скрыто*';
        while (i < words.length) {
            const word = words[i];
            const lowerWord = word.toLowerCase();
    
            // 3a. Проверка на TG-слова
            const isTG = tgWords.some(tgWord => lowerWord.includes(tgWord));
            if (isTG) {
                result.push(word + " "); // оставляем TG слово
                if (i + 1 < words.length) {
                    // скрываем следующий ник/слово после TG
                    result.push(pemen);
                    maskCount++;
                    i += 2;
                    continue;
                }
            }
    
            // 3b. Последовательность слов-цифр через пробел
            if (numberWords.includes(lowerWord)) {
                let j = i;
                while (j < words.length && numberWords.includes(words[j].toLowerCase())) {
                    j++;
                }
                if (j - i >= 3) {
                    result.push(pemen);
                    maskCount++;
                    i = j;
                    continue;
                }
            }
    
            // 3c. Если слово помечено как маска
            if (word.includes("###MASK###")) {
                result.push(pemen);
                maskCount++;
            }
            // 3d. Скрываем никнеймы (англ + цифры) ≥3 символов
            else if (/^[a-zA-Z0-9@._-]{3,}$/.test(word)) {
                result.push(pemen);
                maskCount++;
            }
            else {
                result.push(word + " ");
            }
    
            i++;
        }
    
        return result;
    }
    const removeItem = (indexToRemove) => {
        if(token !== null)
            {
                const data = {
                    id_photo: myProfile.photo.find(item => item.id === indexToRemove).id
                };
                const config = {
                    headers: {
                        Authorization: "Bearer " + token
                    }
                };
                axios.post(`https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/removePhoto`, data,config)
                .then(response => {
                    const updatedPhotos = myProfile.photo.filter((item, index) => item.id !== indexToRemove);
                    const updatedProfile = {
                        ...myProfile,
                        photo: updatedPhotos
                    };
                    setMyProfile(updatedProfile);
                    changeOpenPh(null);
                })
                .catch(error => {
                    console.error('Error uploading image:', error);
                });
           
        };
    
    };
    
    const onChangePhoto = (e,index) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                if(token !== null)
                {
                    
                    const formData = new FormData();
                    formData.append('image', file);
                    formData.append('id_photo', myProfile.photo.find(item => item.id === index).id);
                    
                    const config = {
                        headers: {
                            Authorization: "Bearer " + token,
                            'Content-Type': 'multipart/form-data'
                        }
                    };
        
                    axios.post(`https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/updatePhoto`, formData,config)
                    .then(response => {
                        const updatedProfile = {...myProfile};
                        const currentUnixTime = Math.floor(new Date().getTime() / 1000);
                        updatedProfile.photo.find(item => item.id === index).id = myProfile.photo.find(item => item.id === index).id+'&'+currentUnixTime;
                        setMyProfile(updatedProfile);
                    })
                    .catch(error => {
                        console.error('Error uploading image:', error);
                    });
                }
                
            };
        reader.readAsDataURL(file);
        changeOpenPh(null);
        }
    }
    const PopupOpen = (ind) => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                popup: ind
            }
        }));
    };
    const addPhoto = (e) => {
        const file = e.target.files[0];
        const ids = myProfile.photo.length;
        if(ids < 13)
        {
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    if(token !== null)
                    {
                        
                        const formData = new FormData();
                        formData.append('image', file);
                        
                        const config = {
                            headers: {
                                Authorization: "Bearer " + token,
                                'Content-Type': 'multipart/form-data'
                            }
                        };
            
                        axios.post(`https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/addPhoto`, formData,config)
                        .then(response => {
                            var fileid = response.data.id_file;
                            const updatedProfile = {...myProfile};
                            updatedProfile.photo.push({ id: fileid});
                            setMyProfile(updatedProfile);
                        })
                        .catch(error => {
                            console.error('Error uploading image:', error);
                        });
                    }
                    
                };
            reader.readAsDataURL(file);
            
            }
        }
        else{
            alert('Максимум можно загрузить 13 фотографий!');
        }
    }
    return ((myProfile ?
        <>
        <Photo activePhoto={activePhoto} setActivePhoto={setActivePhoto} />
       <div className={style.flexsettings}>
            <div className={style.blockleft}>
                <h1>Личная информация</h1>
                <div className={style.flexdivph}>
                    {!myProfile.photo || myProfile.photo.length <= 0 ?
                        <div className={style.phs}>
                            <img src={UploadPhotoBig} alt=""/>
                        </div>
                        :
                        (myProfile.photo.map((img, index) => (
                            <div key={index} className={style.phs} >
                                <img src={`https://winxy.ru/static_img.php?id=${img.id}`} alt="" onClick={() => changeOpenPh(index)}/>
                                {openPh === index ?
                                    <div className={style.menuph}>
                                        <div className={style.btnmenuph} onClick={ (() => {
                                            setActivePhoto(`https://winxy.ru/static_img.php?id=${img.id}`);
                                            changeOpenPh(null);
                                        })}>Открыть фотографию</div>
                                        <div className={style.btnmenuph} onClick={
                                            () => {
                                                document.getElementById(`fileInput-${index}`).click();
                                            }
                                           
                                        }>Обновить фотографию</div>
                                        <div className={style.btnmenuph}  onClick={() => removeItem(img.id)}>Удалить фотографию</div>
                                        <div className={style.btnmenuph} onClick={() => changeOpenPh(null)}>Закрыть</div>
                                        <input type="file" id={`fileInput-${index}`} onChange=
                                        { (e) => onChangePhoto(e,img.id)} 
                                        style={{ display: 'none' }} />
                                    </div>
                                    
                                : null }
                            </div>
                        )))
                    }
                </div>
                <p onClick={
                    () => {
                        document.getElementById('addPhoto').click();
                    }
                    
                }>Загрузить другое фото</p>
                <input type="file" id='addPhoto' onChange=
                { (e) => addPhoto(e)} 
                style={{ display: 'none' }} />
                <div className={style.moneys}>
                    <img src={Money} alt=''/>
                    <span>{myProfile.money} монет</span>
                </div>
                <button className={style.btn} onClick={() => PopupOpen(2)}>Пополнить</button>
                <p className={style.bgbb} onClick={() => 
                {
                    setPage(5);
                    setMyProfile(prevState => ({
                        ...prevState,
                        info: {
                            ...prevState.info,
                            profile: null
                        }
                    }));
                }
                    }>Посмотреть свой профиль</p>
            </div>
            <div className={style.rightblock}>
                <div className={style.maxcontent}>
                    <h3>Имя</h3>
                    <input className={style.inputs} onChange={handleNameChange} value={name} placeholder='Ваше имя'/>
                    <h3>Дата рождения</h3>
                    <div className={style.dateinput}>
                        <select value={day} onChange={handleDayChange}>
                            
                            {days.map(d => <option key={d} value={d}>{d}</option>)}
                        </select>
                        <select value={month} onChange={handleMonthChange}>
                            
                            {months.map(m => <option key={m} value={m}>{m}</option>)}
                        </select>
                        <select value={year} onChange={handleYearChange}>
                            
                            {years.map(y => <option key={y} value={y}>{y}</option>)}
                        </select>
                    </div>
                    <h3>Город</h3>
                    <Search customStyle={style.inputb} selected={cityz} setCityChange={setCityz}/>
                    <h3>Цель знакомства</h3>
                    <CustomSelect options={targets} selected={target} setTarget={setTarget}/>
                    <h3>Выбери увлечения</h3>
                    <Radioselect options={hobby} hobbyz={hobbyz} setHobby={setHobby}/>
                </div>
                <div className={style.maxcont}>
                    <div className={style.flextextar}>
                        <h3>О себе</h3>
                        <h4>{opis.length}/200</h4>
                    </div>
                    <textarea className={style.textarez} value={opis} onChange={setTextOpis} maxLength='200'/>
                    <span onClick={SaveProfile}>Сохранить изменения</span>
                </div>
            </div>
       </div>
       </>
    : null ));
}
export default Settings;